import { NameDto } from '../../Common/Types'
import { CurrencyType } from '../../Wallet/Types/Wallet'
import { ClientSubscriptionOverrideDto } from './ClientSubscriptionOverrideDto'

export interface ClientSubscriptionDetailBackOfficeDto {
  id: string
  name: string | null
  type: NameDto
  price: number
  level: NameDto
  currencyId: CurrencyType
  activeViaBundleSubscriptionRequest: null | ClientSubscriptionRequestDto
  subscriptionRequest: null | ClientSubscriptionRequestDto
  clientSubscriptionOverrideDto: null | ClientSubscriptionOverrideDto

  subscription: ClientSubscriptionDto
}

export interface ClientSubscriptionRequestDto {
  id: string
  state: NameDto
  description: string

  type: NameDto
  subscriptionTimeInForce: NameDto
  subscriptionDetailId: string
  dueDate: string
  createdDate: string
}

export enum ClientSubscriptionDetailBackOfficeDtoKey {
  name = 'name',
  type = 'type.name',
  description = 'description',
  level = 'level.id',
  price = 'price',
  currency = 'currencyId',
  status = 'subscriptionRequest.state.name',
}

export interface ClientSubscriptionDto {
  id: string
  name: string
  description: string
  details: ClientSubscriptionDetailDto[]
}

export interface ClientSubscriptionDetailDto {
  id: string
  level: NameDto
  activeSubscriptionRequest?: ClientActiveSubscriptionRequestDto
}

export interface ClientActiveSubscriptionRequestDto {
  id: string
  state: NameDto
  type: NameDto
  subscriptionDetailId: string
  dueDate: string
  createdDate: string
}
